<template>
    <div>
        <div class="tasks-list-wrapper">
            <h1 v-if="list.length">{{ $t('tests.wizard.types.' + type) }} {{$t('tests.tasks_list')}}</h1>
            <h1 v-else>{{$t('tests.test_zero_state.'+ [allEmpty ? 'all_empty' : type] +'.heading')}}</h1>
            <div class="card-box" v-if="list.length">
                <b-card
                        no-body
                        title="Card Title"
                        :img-src="test.images.thumbnail ? test.images.thumbnail : test.image_url"
                        img-alt="Image"
                        img-left
                        tag="article"
                        class="test-card"
                        w-100
                        v-for="test in list"
                        :key="test.id">
                    <b-card-body>
                        <span :class="'state state-'+ type"><em :class="'icon-state-'+ type"></em>{{$t('tests.statuses.'+ type +'')}}</span>
                        <div class="progress-box">
                            <b-progress :value="test.progress" variant="secondary" class="d-inline-flex"></b-progress>
                            <div class="progress-info" v-if="!_.isNull(test.progress)">
                                <span>{{test.progress}}%</span>
                            </div>
                            <div class="progress-info" v-else>
                                <strong>{{$t('tests.progress_unavailable')}}</strong>
                            </div>
                        </div>
                        <ul class="test-info">
                            <li>
								<em class="icon-country"></em>
								<span v-if="test.language_countries_id">{{  getCountryLanguage(test) }}</span>
								<span v-else v-html="$t('tests.custom_value')"></span>
							</li>
                            <li>
                                <em class="icon-yearsold"></em>
                                <span v-if="test.testers_cnt">{{ test.testers_cnt }}</span>
                                <span v-else v-html="$t('tests.custom_value')"></span>
                            </li>
                        </ul>
                    </b-card-body>
                    <div class="control-wrap">
                        <b-button :to="{ name: 'test_results', params: { testId: test.id } }" variant="secondary" v-if="!draft">
                            {{$t('tests.see_results')}}
                        </b-button>
                        <b-button :to="{ name: 'test_edit', params: { testId: test.id } }" variant="secondary" v-else>
                            {{$t('tests.edit_test')}}
                        </b-button>

                        <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret>
                            <template v-slot:button-content>
                                <em class="icon-dot-menu"></em>
                            </template>

                            <b-dropdown-item href="javascript:;" @click="shareLink(test)" v-if="!draft">
                                <span class="default">{{$t('tests.copy_link')}}</span>
                                <span class="copied">{{$t('tests.copied')}}<em class="icon-check-url"></em></span>
                            </b-dropdown-item>

                            <b-dropdown-item href="javascript:;" v-b-modal="'modal-' + test.id">{{$t('tests.delete')}}</b-dropdown-item>
                        </b-dropdown>

                        <!-- confirm delete modal -->
                        <b-modal :id="'modal-' + test.id" centered hide-header>
                            <h2 class="text-center">{{$t('tests.are_you_sure')}}</h2>
                            <template v-slot:modal-footer="{ close }">
                                <div class="w-100 d-flex justify-content-center">
                                    <b-button class="btn mr-2" variant="secondary" @click="close()">
                                        {{$t('tests.cancel')}}
                                    </b-button>
                                    <b-button class="btn" variant="primary" @click="deleteTest(test.id)">
                                        {{$t('tests.delete_btn')}}
                                    </b-button>
                                </div>
                            </template>
                        </b-modal>
                        <!-- confirm delete modal end -->
                    </div>
                </b-card>
            </div>
            <div class="card-box" v-else>
                <b-card
                        no-body
                        tag="article"
                        class="test-card empty"
                        w-100>
                    <b-card-body>
                        <em class="icon-firsttest"></em>
                        <h2>{{$t('tests.test_zero_state.'+ [allEmpty ? 'all_empty' : type] +'.title')}}</h2>
                        <b-card-text>{{$t('tests.test_zero_state.'+ [allEmpty ? 'all_empty' : type] +'.subtitle')}}</b-card-text>
                        <b-button :to="{name:'tests_create'}" class="btn btn-arrow">{{$t('tests.test_zero_state.'+ [allEmpty ? 'all_empty' : type] +'.cta_button')}}<em class="icon-arrow-btn"></em></b-button>
                    </b-card-body>
                </b-card>
            </div>
        </div>
    </div>

</template>

<script>
    import { notifications } from '../../mixins/notifications';
    import { errors } from '../../mixins/errors';
    import { mapMutations, mapGetters } from 'vuex';

    export default {
        props: {
            type: String
        },
        mixins: [
            notifications,
            errors
        ],
        name: 'tests-list',
        created() {
            this.$store.dispatch('options/loadAgeOptions');
            this.$store.dispatch('options/loadCountryLanguageOptions');
        },
        computed: {
            ...mapGetters({
                countryLanguageOptions: 'options/countryLanguageOptions',
				testerAgeOptions: 'options/ageOptions',
            }),
            list() {
                return this.$store.getters['tests/' + this.type + 'Tests'];
            },
            draft() {
                return this.type === 'draft';
            },
            allEmpty() {
                // TODO check if list of all states is empty
                return false;
            },
        },
        methods: {
            shareLink(test) {
                let route = this.$router.resolve({name: 'test-flow-wrapper', params: {hash: test.hash}}),
                        link = window.location.origin + route.href;
                if(this.$clipboard(link)) {
                    this.pushNotification(this.$t('tests.wizard.summary_step.link_copied'), 'success', 2000);
                }
            },
            deleteTest(id) {
                this.$store.dispatch('tests/delete', {status: this.type, testId: id}).then(() => {
                    this.$bvModal.hide('modal-' + id)
                }).catch(e => {
                    this.$bvModal.hide('modal-' + id)
                    this.handleResponseErrors(e);
                });
            },
			getCountryLanguage(test) {
				let option =  _.find(this.countryLanguageOptions, option => option.id === test.language_countries_id);
				return option ? option.language : '---';
			},
			getTesterAge(test) {
				let option =  _.find(this.testerAgeOptions, option => option.id === test.age_ranges_id);
				return option ? option.label : '---';
			}
        }
    }
</script>

<style scoped>

</style>
